import moment from "moment";
import * as Yup from "yup";
const today = moment().format("YYYY-MM-DD");

export const validationSchema = Yup.object().shape({
  PatientID: Yup.string().trim().required("Required"),
  ConsultationReason: Yup.string()
    .trim()
    .matches(/^[\s\S]+$/, "Incorrect format")
    .max(100, "Must be 100 characters or less")
    .required("Required"),
  Status: Yup.string().trim().required("Required"),
  Notes: Yup.string()
    .trim()
    .matches(/^[\s\S]+$/, "Incorrect format")
    .max(100, "Must be 100 characters")
    .required("Required"),
  Priority: Yup.number().integer().max(10, "Must be 10 characters").required("Required"),
  DateFrom: Yup.date()
    .required("Required")
    .test("Is date less", "Appointment cannot be before today's date", (value) => {
      if (!value) return true;
      return moment(today).diff(value) < 0;
    })
    .typeError("Invalid Date!"),
  Duration: Yup.number()
      .transform(value=>(isNaN(value)? undefined:value))
      .max(120, "Duration cannot be longer than 120 minutes")
      .positive()
      .integer()
      .required("Please input an integer representing the duration in minutes")

});

export const editValidationSchema = Yup.object().shape({
  Patient: Yup.object().shape({
    PatientID: Yup.string().required("Required"),
  }),
  ConsultationReason: Yup.string()
    .trim()
    .matches(/^[\s\S]+$/, "Incorrect format")
    .max(100, "Must be 100 characters or less")
    .required("Required"),
  Status: Yup.string().trim().required("Required"),
  Notes: Yup.string()
    .trim()
    .matches(/^[\s\S]+$/, "Incorrect format")
    .max(100, "Must be 100 characters")
    .required("Required"),
  Priority: Yup.number().integer().max(10, "Must be 10 characters").required("Required"),
  DateFrom: Yup.date()
    .required("Required")
    .test("Is date less", "Appointment cannot be before today's date", (value) => {
      if (!value) return true;
      return moment(today).diff(value) < 0;
    })
    .typeError("Invalid Date!"),
  Duration: Yup.number()
      .transform(value=>(isNaN(value)? undefined:value))
      .max(120, "Duration cannot be longer than 120 minutes")
      .positive()
      .integer()
      .required("Please input an integer representing the duration in minutes")
});
